<app-header [publicPage]="true"></app-header>

<div class="login-page">

  <!-- ── Left panel (desktop ≥ 1024px) ─────────────────────────────────── -->
  <div class="left-panel">

    <!-- Same opening as the isoFarm page on tecomec.com.br; the brand is in the header -->
    <div class="left-panel__main">
      <p class="left-panel__eyebrow">
        <span class="left-panel__eyebrow-dot" aria-hidden="true"></span>
        {{ 'login-page.left.h1' | translate }}
      </p>
      <h1>{{ 'login-page.left.title' | translate }}</h1>

      <p class="subtitle">
        {{ 'login-page.left.subtitle' | translate }}
      </p>
    </div>

    <!-- App stores and integrations, right above the footer -->
    <div class="left-panel__links">
      <!-- App store badges -->
      <div class="left-panel__apps">
        <p class="left-panel__section-label">
          {{ 'login-page.left.app-section-title' | translate }}
        </p>
        <div class="left-panel__badges">
          <a
            [href]="googlePlayLink"
            target="_blank"
            rel="noopener noreferrer"
            [attr.aria-label]="'login-page.right.google-play-alt' | translate"
          >
            <img
              [src]="'./assets/images/login-page/google-play-badge.png'"
              [alt]="'login-page.right.google-play-alt' | translate"
              class="left-panel__badge-img"
            />
          </a>
          <a
            [href]="appStoreLink"
            target="_blank"
            rel="noopener noreferrer"
            [attr.aria-label]="'login-page.right.app-store-alt' | translate"
          >
            <img
              [src]="'./assets/images/login-page/apple-badge.png'"
              [alt]="'login-page.right.app-store-alt' | translate"
              class="left-panel__badge-img"
            />
          </a>
        </div>
      </div>

      <!-- Integrations -->
      <div class="left-panel__integrations">
        <p class="left-panel__section-label">
          {{ 'login-page.left.agrirouter-title' | translate }}
        </p>
        <div class="left-panel__integration-logos">
          <span class="left-panel__integration-tile">
            <img
              src="./assets/images/agrirouter/agrirouter.svg"
              [alt]="'login-page.right.agrirouter-alt' | translate"
              class="left-panel__integration-logo left-panel__integration-logo--agrirouter" />
          </span>
          <span class="left-panel__integration-tile">
            <img
              src="./assets/images/login-page/logo-login-black.png"
              alt="xFarm"
              class="left-panel__integration-logo left-panel__integration-logo--xfarm" />
          </span>
          <span class="left-panel__integration-tile">
            <img
              src="./assets/images/john-deere/john-deere-operations-center-connected.svg"
              alt="John Deere"
              class="left-panel__integration-logo left-panel__integration-logo--john-deere" />
          </span>
        </div>
      </div>
    </div>

    <p class="left-panel__footer">
      {{ 'login-page.left.footer-description' | translate }}
      <a class="left-panel__more" [href]="digitalAgricultureLink" target="_blank" rel="noopener noreferrer">
        {{ 'login-page.left.footer-btn' | translate }}<span aria-hidden="true"> →</span>
      </a>
    </p>

  </div>

  <!-- ── Right panel ────────────────────────────────────────────────────── -->
  <div class="right-panel">

    <!-- Mobile hero: logo + title + subtitle (hidden on desktop) -->
    <div class="mobile-hero">
      <div class="mobile-hero__logo">
        <img src="assets/images/default/logo-isofarm.svg" alt="isoFarm" />
      </div>
      <h1 class="mobile-hero__title">{{ 'login-page.left.h1' | translate }}</h1>
      <p class="mobile-hero__subtitle">{{ 'login-page.left.subtitle' | translate }}</p>
    </div>

    <!-- Form card -->
    <div class="form-card">
      <div class="form-card__view">
        <app-login-form
          *ngIf="activeView === 'login'"
          [@slideLeft]
          (changeView)="activeView = $event"
        />
        <app-register-form
          *ngIf="activeView === 'register'"
          [@slideLeft]
          (changeView)="activeView = $event"
        />
        <app-forgot-password-form
          *ngIf="activeView === 'forgot-password'"
          [@slideLeft]
          (changeView)="activeView = $event"
        />
      </div>
    </div>

    <p class="right-panel__copyright">{{ 'login-page.login.copyright' | translate }}</p>

    <!-- Mobile apps: badges + integrations (hidden on desktop) -->
    <div class="mobile-apps">
      <div class="mobile-apps__badges">
        <a
          [href]="googlePlayLink"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="'login-page.right.google-play-alt' | translate"
        >
          <img
            [src]="'./assets/images/login-page/google-play-badge.png'"
            [alt]="'login-page.right.google-play-alt' | translate"
            class="mobile-apps__badge-img"
          />
        </a>
        <a
          [href]="appStoreLink"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="'login-page.right.app-store-alt' | translate"
        >
          <img
            [src]="'./assets/images/login-page/apple-badge.png'"
            [alt]="'login-page.right.app-store-alt' | translate"
            class="mobile-apps__badge-img"
          />
        </a>
      </div>

      <div class="mobile-apps__integrations">
        <img
          src="./assets/images/agrirouter/agrirouter.svg"
          [alt]="'login-page.right.agrirouter-alt' | translate"
          class="mobile-apps__integration-logo"
        />
        <img
          src="./assets/images/login-page/logo-login-black.png"
          alt="xFarm"
          class="mobile-apps__integration-logo mobile-apps__integration-logo--xfarm"
        />
        <img
          src="./assets/images/john-deere/john-deere-operations-center-connected.svg"
          alt="John Deere"
          class="mobile-apps__integration-logo mobile-apps__integration-logo--john-deere"
        />
      </div>
    </div>
  </div>

  <!-- Mobile footer bar: fixed at bottom (hidden on desktop) -->
  <div class="mobile-footer-bar">
    <p class="mobile-footer-bar__description">{{ 'login-page.left.footer-description' | translate }}</p>
    <a
      class="btn-primary mobile-footer-bar__btn"
      [href]="digitalAgricultureLink"
      target="_blank"
      rel="noopener noreferrer">
      {{ 'login-page.left.footer-btn' | translate }}
    </a>
  </div>

</div>
